import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { CustomizerMenuPartModel } from "@models/customizer-menu-part";
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageService } from '@services/language.service';
import { Subscription } from 'rxjs';
import { GenericInfoModalComponent } from "../../../../_modals/generic/generic-info.modal";
import { ModalService } from '../../../../_services/modal.service';
import { CustomizerStateConstants } from "../../../../shared/customizer-state-constants";
import { UserService } from './../../../../_services/user.service';

@Component({
    selector: "add-to-bag-button",
    templateUrl: 'add-to-bag-button.component.html',
    styleUrls: ['./add-to-bag-button.component.scss'],
    imports: [TranslatePipe, CommonModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class AddToBagButtonComponent implements OnInit, OnDestroy {

	@Input() added: boolean;
	@Input() disabled: boolean;
	@Input() parts: number = 0;

	@Output() addToBagChange: EventEmitter<void> = new EventEmitter();

	public canAdd: boolean;
	public userHasAddToBagPermission: boolean;
	public engravingSubscription: Subscription = new Subscription();
	public customizerStateEnum = CustomizerStateConstants;
	public components: Array<CustomizerMenuPartModel>;

	constructor(
		private userService: UserService,
		private modalService: ModalService,
		private translateService: LanguageService
	) { }

	async ngOnInit() {
		this.userHasAddToBagPermission = await this.userService.UserHasAddToBagPermission();
		this.canAdd = await this.userService.UserCanAddToBag();
		this.engravingSubscription = this.userService.userCanAddChanges.subscribe(async () => {
			this.canAdd = await this.userService.UserCanAddToBag();
		});
	}

	ngOnDestroy() {
		this.engravingSubscription.unsubscribe();
	}

	public async addToBag() {
		if (this.canAdd) {
			this.addToBagChange.emit();
		}
	}

	public cannotAddClick() {
		if (!this.userHasAddToBagPermission) {
			const input = {
				title: this.translateService.instant(`CUSTOMIZER.UNAUTHORISEDADDTOBAG.HEADER`),
				contentPart1: this.translateService.instant(`CUSTOMIZER.UNAUTHORISEDADDTOBAG.PART1`),
				contentPart2: this.translateService.instant(`CUSTOMIZER.UNAUTHORISEDADDTOBAG.PART2`),
				contentPart3: this.translateService.instant(`CUSTOMIZER.UNAUTHORISEDADDTOBAG.PART3`)
			};

			this.modalService.create(GenericInfoModalComponent, input);
		}
	}

}
